import { render, staticRenderFns } from "./LatentDangerListExpand.vue?vue&type=template&id=51d85720&scoped=true&"
import script from "./LatentDangerListExpand.vue?vue&type=script&lang=js&"
export * from "./LatentDangerListExpand.vue?vue&type=script&lang=js&"
import style0 from "./LatentDangerListExpand.vue?vue&type=style&index=0&id=51d85720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d85720",
  null
  
)

export default component.exports